// =====================================================================================
// FILE: src/components/UpdateBanner.jsx
// Shows a persistent banner when a new deployment is detected.
// Drop into both club and commercial repos.
// =====================================================================================
import React from "react";
import { useVersionCheck } from "../hooks/useVersionCheck";

export default function UpdateBanner() {
  const { updateAvailable, refresh } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
        borderTop: "2px solid #2dd4bf",
        padding: "12px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        boxShadow: "0 -4px 20px rgba(0,0,0,0.4)",
        animation: "slideUp 0.3s ease-out",
      }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes pulse-dot {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
      `}</style>

      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          background: "#2dd4bf",
          animation: "pulse-dot 1.5s ease-in-out infinite",
          flexShrink: 0,
        }}
      />

      <span style={{ color: "#e2e8f0", fontSize: 13, fontWeight: 500 }}>
        A new version of VenueFlow is available
      </span>

      <button
        onClick={refresh}
        style={{
          background: "#2dd4bf",
          color: "#0f172a",
          border: "none",
          borderRadius: 6,
          padding: "6px 20px",
          fontSize: 12,
          fontWeight: 700,
          cursor: "pointer",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          transition: "all 0.15s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#5eead4";
          e.currentTarget.style.transform = "scale(1.02)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#2dd4bf";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        Refresh Now
      </button>
    </div>
  );
}
